import { useEffect, useContext } from 'react'
import styles from './styles.module.css'
import { Input, Select, Checkbox } from '../../../components/ModalInputs'
import { StaffRosterContext } from '../../../utils/context'

const militaryRanks = [
  { value: '', name: '' },
  { value: 'Рядовой', name: 'Рядовой' },
  { value: 'Матрос', name: 'Матрос' },
  { value: 'Ефрейтор', name: 'Ефрейтор' },
  { value: 'Старший матрос', name: 'Старший матрос' },
  { value: 'Младший сержант', name: 'Младший сержант' },
  { value: 'Старшина 2 статьи', name: 'Старшина 2 статьи' },
  { value: 'Сержант', name: 'Сержант' },
  { value: 'Старшина 1 статьи', name: 'Старшина 1 статьи' },
  { value: 'Старший сержант', name: 'Старший сержант' },
  { value: 'Главный старшина', name: 'Главный старшина' },
  { value: 'Старшина', name: 'Старшина' },
  { value: 'Прапорщик', name: 'Прапорщик' },
  { value: 'Мичман', name: 'Мичман' },
  { value: 'Старший прапорщик', name: 'Старший прапорщик' },
  { value: 'Старший мичман', name: 'Старший мичман' }
]

const fitnessCategories = [
  { value: '', name: '' },
  { value: 'А', name: 'А - годные к военной службе' },
  { value: 'Б', name: 'Б - годные к военной службе с незначительными ограничениями' },
  { value: 'В', name: 'В - ограниченно годные к военной службе' },
  { value: 'Г', name: 'Г - временно не годные к военной службе' },
  { value: 'Д', name: 'Д - не годные к военной службе' }
]

const removalReasons = [
  { value: '', name: '' },
  { value: 'age', name: 'Снят с воинского учета по возрасту' },
  { value: 'health', name: 'Снят с воинского учета по состоянию здоровья' }
]

const reserveCategories = [
  { value: '', name: '' },
  { value: '1', name: '1 категория' },
  { value: '2', name: '2 категория' },
  { value: '3', name: '3 категория' }
]

export default function MilitaryRecord() {
  const { allForms, addMode, personTabData } = useContext(StaffRosterContext)
  const { handleChange, setValues } = allForms

  const { militaryRecord } = personTabData || {}
  const military = militaryRecord || {}

  // Синхронизация формы с данными из API
  useEffect(() => {
    if (!addMode && militaryRecord) {
      const data = militaryRecord
      setValues(prev => ({
        ...prev,
        reserveCategory: data.reserve_category || data.reserveCategory || '',
        militaryRank: data.military_rank || data.militaryRank || '',
        composition: data.composition || '',
        vusCode: data.vus_code || data.vusCode || '',
        fitnessCategory: data.fitness_category || data.fitnessCategory || '',
        commissariatName: data.commissariat_name || data.commissariatName || '',
        registrationStatus: data.registration_status || data.registrationStatus || '',
        isGeneral: data.is_general || data.isGeneral || false,
        isSpecial: data.is_special || data.isSpecial || false,
        removalReason: data.removal_reason || data.removalReason || ''
      }))
    }
  }, [militaryRecord, addMode, setValues])

  return (
    <div className={styles.tabWrapper}>
      {/* Форма */}
      <div className={styles.qualificationForm}>
        {/* Строка 1 */}
        <div className={styles.inputsRow}>
          <Select
            label="Категория запаса"
            name="reserveCategory"
            value={military?.reserve_category || military?.reserveCategory || ''}
            onChange={handleChange}
          >
            {reserveCategories.map(r => <option key={r.value} value={r.value}>{r.name}</option>)}
          </Select>
          <Select
            label="Воинское звание"
            name="militaryRank"
            value={military?.military_rank || military?.militaryRank || ''}
            onChange={handleChange}
          >
            {militaryRanks.map(r => <option key={r.value} value={r.value}>{r.name}</option>)}
          </Select>
        </div>

        {/* Строка 2 */}
        <div className={styles.inputsRow}>
          <Input
            label="Состав (профиль)"
            name="composition"
            value={military?.composition || ''}
            onChange={handleChange}
          />
          <Input
            label="Полное кодовое обозначение ВУС"
            name="vusCode"
            value={military?.vus_code || military?.vusCode || ''}
            onChange={handleChange}
          />
        </div>

        {/* Строка 3 */}
        <div className={styles.inputsRow}>
          <Select
            label="Категория годности к военной службе"
            name="fitnessCategory"
            value={military?.fitness_category || military?.fitnessCategory || ''}
            onChange={handleChange}
          >
            {fitnessCategories.map(c => <option key={c.value} value={c.value}>{c.name}</option>)}
          </Select>
        </div>

        {/* Строка 4 */}
        <div className={styles.inputsRow}>
          <Input
            label="Наименование военного комиссариата по месту жительства"
            name="commissariatName"
            value={military?.commissariat_name || military?.commissariatName || ''}
            onChange={handleChange}
          />
        </div>

        {/* Строка 5 */}
        <div className={styles.inputsRow}>
          <Input
            label="Состоит на воинском учете"
            name="registrationStatus"
            value={military?.registration_status || military?.registrationStatus || ''}
            onChange={handleChange}
          />
          <Checkbox
            label="Общий"
            name="isGeneral"
            checked={military?.is_general || military?.isGeneral || false}
            onChange={handleChange}
          />
          <Checkbox
            label="Специальный"
            name="isSpecial"
            checked={military?.is_special || military?.isSpecial || false}
            onChange={handleChange}
          />
        </div>

        {/* Строка 6 */}
        <div className={styles.inputsRow}>
          <Select
            label="Отметка о снятии с воинского учета"
            name="removalReason"
            value={military?.removal_reason || military?.removalReason || ''}
            onChange={handleChange}
          >
            {removalReasons.map(r => <option key={r.value} value={r.value}>{r.name}</option>)}
          </Select>
        </div>
      </div>
    </div>
  )
}
